/**
 * ENMECA — Shopify product page → designer handoff
 *
 * Keeps the "Customize, Preview, or Request a Design" link aligned with the
 * currently selected Color + Quantity.
 *
 * Does NOT put Shopify variant IDs in the designer URL (Django resolves cart variants).
 * Does NOT require a Dawn Add to Cart / product-form (external-designer products
 * suppress buy-buttons). Color and Quantity are read from variant-selects /
 * variant-radios DOM state.
 *
 * Install: see THEME_INSTALL_em_designer_handoff.txt
 */
(function () {
  'use strict';

  if (window.__EMDesignerHandoffLoaded) {
    return;
  }
  window.__EMDesignerHandoffLoaded = true;

  var COLOR_OPTION_NAMES = ['color', 'card color', 'finish', 'card finish'];
  var QTY_OPTION_NAMES = [
    'quantity',
    'number of cards',
    'number of tags',
    'pack size',
    'pack quantity',
    'cards',
    'tags',
  ];

  var lastPublishedVariant = null;

  function isTwoSidedDesignerUrl(base) {
    return /\/preview\/two-sided(\/|$|\?)/i.test(String(base || ''));
  }

  function basicColorSlug(raw) {
    return String(raw || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  /**
   * Legacy /preview/design/ convention: Color "Black" → black-card.
   * Two-sided designers use basicColorSlug instead (Black → black; Django
   * aliases that onto black-card / black-tag).
   */
  function slugifyColorToFinishSlug(raw) {
    var s = basicColorSlug(raw);
    if (!s) {
      return '';
    }
    if (s.slice(-5) !== '-card' && s.slice(-4) !== '-tag') {
      s = s + '-card';
    }
    return s;
  }

  function colorSlugForDesignerUrl(raw, base) {
    if (isTwoSidedDesignerUrl(base)) {
      return basicColorSlug(raw);
    }
    return slugifyColorToFinishSlug(raw);
  }

  function parsePackQuantity(raw) {
    var m = String(raw || '').match(/(\d+)/);
    if (!m) {
      return '';
    }
    var n = parseInt(m[1], 10);
    return !isNaN(n) && n >= 1 ? String(n) : '';
  }

  function normalizeOptionName(raw) {
    return String(raw || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function optionIndexByNames(product, names) {
    var opts = (product && product.options) || [];
    var i;
    var j;
    for (i = 0; i < opts.length; i++) {
      var name = String(
        typeof opts[i] === 'string' ? opts[i] : opts[i] && opts[i].name
          ? opts[i].name
          : ''
      )
        .trim()
        .toLowerCase();
      for (j = 0; j < names.length; j++) {
        if (name === names[j]) {
          return i;
        }
      }
    }
    return -1;
  }

  function nameMatchesList(name, names) {
    var n = normalizeOptionName(name);
    var i;
    if (!n) {
      return false;
    }
    for (i = 0; i < names.length; i++) {
      if (n === names[i]) {
        return true;
      }
    }
    return false;
  }

  function optionNameFromControl(el) {
    if (!el) {
      return '';
    }
    var fromData = el.getAttribute && el.getAttribute('data-option-name');
    if (fromData) {
      return String(fromData).replace(/\s+/g, ' ').trim();
    }
    var name = String(el.name || el.getAttribute && el.getAttribute('name') || '')
      .replace(/\s+/g, ' ')
      .trim();
    var optMatch = name.match(/^options\[(.+)\]$/i);
    if (optMatch) {
      return optMatch[1].trim();
    }
    var posMatch = name.match(/^(.*)-(\d+)$/);
    if (posMatch) {
      return posMatch[1].trim();
    }
    return name;
  }

  function optionNameFromFieldset(fs) {
    if (!fs) {
      return '';
    }
    var legend = fs.querySelector('legend');
    if (!legend) {
      return '';
    }
    var clone = legend.cloneNode(true);
    var selected = clone.querySelector('[data-selected-value]');
    if (selected && selected.parentNode) {
      selected.parentNode.removeChild(selected);
    }
    return String(clone.textContent || '')
      .replace(/\s+/g, ' ')
      .replace(/:\s*$/, '')
      .trim();
  }

  function getMainPickerRoot() {
    var main =
      document.querySelector('product-info[id^="MainProduct"]') ||
      document.querySelector('product-info');
    var scoped = main
      ? main.querySelector('variant-selects') || main.querySelector('variant-radios')
      : null;
    return (
      scoped ||
      document.querySelector('variant-selects') ||
      document.querySelector('variant-radios') ||
      null
    );
  }

  /**
   * Dawn variant picker state (works with or without a product form).
   *
   * Current Dawn (variant-selects): radios named Color-1 / Quantity-2, checked
   * when selected; legend [data-selected-value] updated immediately on change.
   * Older Dawn used variant-radios with name="Color".
   * Buy-button suppression does not remove this picker.
   */
  function readPickerSelections() {
    var out = {};
    var root = getMainPickerRoot();
    if (!root) {
      return out;
    }
    var fieldsets = root.querySelectorAll('fieldset');
    var i;
    for (i = 0; i < fieldsets.length; i++) {
      var fs = fieldsets[i];
      var checked = fs.querySelector('input:checked');
      var name = '';
      var value = '';
      if (checked) {
        name = optionNameFromControl(checked) || optionNameFromFieldset(fs);
        value = String(checked.value || '').trim();
      }
      if (!value) {
        var sv = fs.querySelector('[data-selected-value]');
        if (sv) {
          value = String(sv.textContent || '').trim();
        }
        if (!name) {
          name = optionNameFromFieldset(fs);
        }
      }
      if (name && value) {
        out[normalizeOptionName(name)] = value;
      }
    }
    var selects = root.querySelectorAll('select');
    for (i = 0; i < selects.length; i++) {
      var sel = selects[i];
      var opt = sel.selectedOptions && sel.selectedOptions[0]
        ? sel.selectedOptions[0]
        : sel.options && sel.selectedIndex >= 0
          ? sel.options[sel.selectedIndex]
          : null;
      var selName =
        (opt && optionNameFromControl(opt)) ||
        optionNameFromControl(sel);
      var selValue = opt
        ? String(opt.value || opt.textContent || '').trim()
        : String(sel.value || '').trim();
      if (selName && selValue) {
        out[normalizeOptionName(selName)] = selValue;
      }
    }
    return out;
  }

  function valueFromPickerMap(map, names) {
    var i;
    var key;
    if (!map) {
      return '';
    }
    for (i = 0; i < names.length; i++) {
      if (map[names[i]]) {
        return map[names[i]];
      }
    }
    for (key in map) {
      if (Object.prototype.hasOwnProperty.call(map, key) && nameMatchesList(key, names)) {
        return map[key];
      }
    }
    return '';
  }

  function readVariantIdFromUrl() {
    try {
      return String(new URLSearchParams(window.location.search).get('variant') || '').trim();
    } catch (e) {
      return '';
    }
  }

  function readSelectedVariantJson() {
    var el = document.querySelector(
      'variant-selects [data-selected-variant], variant-radios [data-selected-variant]'
    );
    if (!el) {
      return null;
    }
    try {
      return JSON.parse(el.textContent || 'null');
    } catch (e2) {
      return null;
    }
  }

  /**
   * Do not treat a generic page-wide name=id input as the selected variant.
   *
   * On external-designer PDPs the only remaining name=id is the Shop Pay
   * installment form in main-product.liquid:
   *   {% form 'product', product, id: product_form_installment_id, class: 'installment' %}
   *   <input type="hidden" name="id" value="{{ selected variant id }}">
   *
   * Measured on custom-engraved-round-metal-tag:
   *   - Radios use form="product-form-{section}" (buy-buttons form).
   *   - That buy-buttons form is not rendered.
   *   - Radios are therefore NOT associated with the installment form.
   *   - Default installment id is Black/1 (51001984581865).
   *   - A Color/Quantity click does not natively update that input.
   *   - Dawn product-info.js may rewrite it later via updateVariantInputs()
   *     after an async section fetch — too late and not authoritative.
   *   - Full-page ?variant= and the section_id+option_values fetch DO render
   *     a new Liquid value; that is server HTML, not the live input at click.
   */
  function isInstallmentVariantInput(el) {
    if (!el || !el.closest) {
      return false;
    }
    var form = el.closest('form');
    if (!form) {
      return false;
    }
    var id = String(form.id || '');
    var cls = String(form.className || '');
    return (
      cls.indexOf('installment') !== -1 ||
      id.indexOf('product-form-installment') !== -1
    );
  }

  function findVariant(product, variantId) {
    var list = (product && product.variants) || [];
    var i;
    var want = String(variantId || '').trim();
    if (!want) {
      return null;
    }
    for (i = 0; i < list.length; i++) {
      if (String(list[i].id) === want) {
        return list[i];
      }
    }
    return null;
  }

  function selectionsFromVariant(product, variant) {
    var colorIdx = optionIndexByNames(product, COLOR_OPTION_NAMES);
    var qtyIdx = optionIndexByNames(product, QTY_OPTION_NAMES);
    var options = (variant && variant.options) || [];
    var colorRaw =
      colorIdx >= 0 && options[colorIdx] != null
        ? options[colorIdx]
        : variant && variant.option1;
    var qtyRaw =
      qtyIdx >= 0 && options[qtyIdx] != null
        ? options[qtyIdx]
        : variant && variant.option2;
    return {
      colorRaw: colorRaw || '',
      finishSlug: basicColorSlug(colorRaw),
      quantity: parsePackQuantity(qtyRaw),
    };
  }

  function readInitialSelectionsFromLink(link) {
    if (!link || !link.getAttribute) {
      return { colorRaw: '', quantity: '' };
    }
    return {
      colorRaw: String(link.getAttribute('data-em-initial-color') || '').trim(),
      quantity: parsePackQuantity(link.getAttribute('data-em-initial-quantity') || ''),
    };
  }

  /**
   * Resolve Color + Quantity without requiring a cart form.
   * Priority:
   *   1. variant-selects / variant-radios checked radios, selects, data-selected-value
   *   2. Dawn PUB_SUB_EVENTS.variantChange payload
   *   3. URL ?variant=<id> matched against product.variants
   *   4. [data-selected-variant] JSON inside the picker (updated after section fetch)
   *   5. Liquid data-em-initial-color / data-em-initial-quantity on the link
   *
   * Never use the installment-form input[name=id] (see isInstallmentVariantInput).
   */
  function readCurrentSelections(product, link) {
    var picker = readPickerSelections();
    var colorRaw = valueFromPickerMap(picker, COLOR_OPTION_NAMES);
    var qtyRaw = valueFromPickerMap(picker, QTY_OPTION_NAMES);
    var variant = null;
    var fromVariant;
    var initial;

    if (!colorRaw || !qtyRaw) {
      variant =
        lastPublishedVariant ||
        findVariant(product, readVariantIdFromUrl()) ||
        readSelectedVariantJson();
      if (variant) {
        fromVariant = selectionsFromVariant(product, variant);
        if (!colorRaw) {
          colorRaw = fromVariant.colorRaw;
        }
        if (!qtyRaw) {
          qtyRaw = fromVariant.quantity;
        }
      }
    }

    if ((!colorRaw || !qtyRaw) && link) {
      initial = readInitialSelectionsFromLink(link);
      if (!colorRaw) {
        colorRaw = initial.colorRaw;
      }
      if (!qtyRaw) {
        qtyRaw = initial.quantity;
      }
    }

    return {
      colorRaw: colorRaw || '',
      quantity: parsePackQuantity(qtyRaw),
    };
  }

  function buildDesignerUrl(base, finishSlug, quantity) {
    var u;
    try {
      u = new URL(base, window.location.href);
    } catch (e) {
      return base;
    }
    u.searchParams.delete('finish');
    u.searchParams.delete('card');
    u.searchParams.delete('quantity');
    if (finishSlug) {
      if (isTwoSidedDesignerUrl(base)) {
        u.searchParams.set('finish', finishSlug);
      } else {
        u.searchParams.set('card', finishSlug);
      }
    }
    if (quantity) {
      u.searchParams.set('quantity', quantity);
    }
    return u.pathname + u.search + u.hash;
  }

  function syncLink(link, product) {
    if (!link || !product) {
      return;
    }
    var base =
      link.getAttribute('data-em-designer-base') ||
      link.getAttribute('href') ||
      '';
    if (!base) {
      return;
    }
    var sel = readCurrentSelections(product, link);
    var finishSlug = colorSlugForDesignerUrl(sel.colorRaw, base);
    var href = buildDesignerUrl(base, finishSlug, sel.quantity);
    try {
      var abs = new URL(base, window.location.href);
      var built = new URL(href, abs.origin);
      link.setAttribute('href', built.toString());
    } catch (e2) {
      link.setAttribute('href', href);
    }
  }

  function isDesignerPreviewHref(href) {
    var s = String(href || '');
    if (/design-with-ai/i.test(s)) {
      return false;
    }
    return (
      /\/preview\/two-sided(\/|$|\?)/i.test(s) || /\/preview\/design(\/|$|\?)/i.test(s)
    );
  }

  function collectDesignerLinks() {
    var out = [];
    var seen = [];
    var nodes;
    var i;
    var el;
    function add(node) {
      if (!node || seen.indexOf(node) !== -1) {
        return;
      }
      seen.push(node);
      out.push(node);
    }
    nodes = document.querySelectorAll('[data-em-designer-handoff]');
    for (i = 0; i < nodes.length; i++) {
      add(nodes[i]);
    }
    nodes = document.querySelectorAll('a[href]');
    for (i = 0; i < nodes.length; i++) {
      el = nodes[i];
      if (isDesignerPreviewHref(el.getAttribute('href'))) {
        add(el);
      }
    }
    return out;
  }

  function parseProductJson(el) {
    if (!el) {
      return null;
    }
    try {
      return JSON.parse(el.textContent || 'null');
    } catch (e) {
      return null;
    }
  }

  function init() {
    var links = collectDesignerLinks();
    if (!links.length) {
      return;
    }
    var jsonEl = document.getElementById('em-designer-handoff-product-json');
    var product = parseProductJson(jsonEl) || { options: [], variants: [] };

    function refreshAll() {
      var i;
      links = collectDesignerLinks();
      for (i = 0; i < links.length; i++) {
        syncLink(links[i], product);
      }
    }

    function rememberPublishedVariant(evt) {
      var data = evt && evt.data ? evt.data : evt;
      var variant = data && data.variant ? data.variant : null;
      if (variant && variant.id) {
        lastPublishedVariant = variant;
      }
      refreshAll();
    }

    function bindPubSub() {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
        return false;
      }
      try {
        if (PUB_SUB_EVENTS.variantChange) {
          subscribe(PUB_SUB_EVENTS.variantChange, rememberPublishedVariant);
        }
        if (PUB_SUB_EVENTS.optionValueSelectionChange) {
          subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, refreshAll);
        }
        return true;
      } catch (e3) {
        return false;
      }
    }

    refreshAll();

    document.addEventListener(
      'click',
      function (ev) {
        var t = ev.target;
        var link = t && t.closest ? t.closest('[data-em-designer-handoff]') : null;
        if (!link && t && t.closest) {
          var a = t.closest('a');
          if (a && isDesignerPreviewHref(a.getAttribute('href'))) {
            link = a;
          }
        }
        if (!link) {
          return;
        }
        syncLink(link, product);
      },
      true
    );

    document.addEventListener(
      'change',
      function (ev) {
        var t = ev.target;
        if (!t) {
          return;
        }
        if (
          t.closest('variant-selects') ||
          t.closest('variant-radios') ||
          t.closest('[data-product-options]')
        ) {
          refreshAll();
        }
      },
      true
    );

    document.addEventListener('variant:change', function (ev) {
      var detail = ev && ev.detail;
      var variant = detail && (detail.variant || detail);
      if (variant && variant.id) {
        lastPublishedVariant = variant;
      }
      refreshAll();
    });
    document.addEventListener('product-info:loaded', refreshAll);

    if (!bindPubSub()) {
      document.addEventListener('DOMContentLoaded', bindPubSub);
      window.addEventListener('load', bindPubSub);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.EMDesignerHandoff = {
    slugifyColorToFinishSlug: slugifyColorToFinishSlug,
    basicColorSlug: basicColorSlug,
    colorSlugForDesignerUrl: colorSlugForDesignerUrl,
    isTwoSidedDesignerUrl: isTwoSidedDesignerUrl,
    parsePackQuantity: parsePackQuantity,
    buildDesignerUrl: buildDesignerUrl,
    selectionsFromVariant: selectionsFromVariant,
    optionIndexByNames: optionIndexByNames,
    findVariant: findVariant,
    readPickerSelections: readPickerSelections,
    readCurrentSelections: readCurrentSelections,
    optionNameFromControl: optionNameFromControl,
    isInstallmentVariantInput: isInstallmentVariantInput,
    isDesignerPreviewHref: isDesignerPreviewHref,
    collectDesignerLinks: collectDesignerLinks,
  };
})();